import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';

function WriteMultyPopup(props: any) {
  const myProps = {
    closePopup: () => { },
    callback: () => { },
    isUpdate: false,
    listOpt: {},
    row_num: 0,
    key: "",
    cust_par_id: "user",
    cust_par_seq: "",
    cust_name: "",
    a_subject_detail: "",
    add_btn_arr: [
      { "a_inout": "in", "a_memo": "입금", "a_money_type": "money" },
      { "a_inout": "in", "a_memo": "청구", "a_money_type": "debt" },
      // {"a_inout":"out","a_memo":"지출","a_money_type":"money"},
    ],
    is_show_cust_name: false,
    is_show_money_type: true,
    is_show_in_out: true,
    callBackData: (data: any) => {
      let optObj = {
        info_arr: [],
        row_num: 0,
        key: "",
      };
    },//data = { info_arr:[],row_num:0,key:"" };
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  for (let i = 0; i < xColumnArr.x_column_list_arr.length; i++) {
    let key = xColumnArr.x_column_list_arr[i]["key"];
    if (key == "a_cust_name") {
      if (myProps.is_show_cust_name) {
        xColumnArr.x_column_list_arr[i]["is_show"] = "1";
      } else {
        xColumnArr.x_column_list_arr[i]["is_show"] = "";
      }
    }
    if (key == "a_money_type") {
      if (myProps.is_show_money_type) {
        xColumnArr.x_column_list_arr[i]["is_show"] = "1";
      } else {
        xColumnArr.x_column_list_arr[i]["is_show"] = "";
      }
    }
    if (key == "a_inout") {
      if (myProps.is_show_in_out) {
        xColumnArr.x_column_list_arr[i]["is_show"] = "1";
      } else {
        xColumnArr.x_column_list_arr[i]["is_show"] = "";
      }
    }
  }
  const ListComponentRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    ...myProps.listOpt
  });
  const [infoArr, setInfoArr] = useState<any>([]);

  useEffect(() => {

  }, []);

  let default_row_data = {
    "a_ymd": DateFunc.get_date_format(new Date(), "Ymd"),
    "a_seq": "",
    "a_corp_seq": user.corp_seq,
    "a_user_seq": user.user_seq,
    "a_cust_par_id": myProps.cust_par_id,
    "a_cust_par_seq": myProps.cust_par_seq,
    "a_cust_name": myProps.cust_name,
    "a_par_id": "",
    "a_par_seq": "",
    "a_date": DateFunc.get_date_format(new Date(), "Y-m-d"),
    "a_is_tax_bill": "",
    "a_tax_seq": "",
    "a_is_tax_sort": "",
    "a_tax_sort": "",
    "a_money": "0",
    "a_subject_code": "",
    "a_subject_name": "",
    "a_subject_detail": myProps.a_subject_detail,
    "a_money_type": "money",//money,debt
    "a_inout": "in",//in,out
    "a_memo": "",
  };

  const addRowByData = (inRowData: any) => {
    let rowData = {
      ...default_row_data,
      ...inRowData
    };
    let info_arr = [...infoArr];
    if (ListComponentRef.current) {
      info_arr = ListComponentRef.current.getRows();
      info_arr.push(rowData);
      ListComponentRef.current.setInfoArr(info_arr);
      setInfoArr(info_arr);
    }
  };

  const removeRowByData = () => {
    if (ListComponentRef.current == null) {
      return false;
    }
    let all_rows = ListComponentRef.current.getRows();
    let select_rows = ListComponentRef.current.getSelectedRows();
    let now_rows = [];
    for (let i = 0; i < all_rows.length; i++) {
      let is_select = false;
      for (let j = 0; j < select_rows.length; j++) {
        if (select_rows[j].idx_num == i) {
          is_select = true;
        }
      }
      if (is_select == false) {
        now_rows.push(all_rows[i]);
      }
    }
    ListComponentRef.current.setInfoArr(now_rows);
    setInfoArr(now_rows);
  };

  const onWriteMulty = () => {
    let select_rows: any = [];
    if (ListComponentRef.current) {
      select_rows = ListComponentRef.current.getRows();
    }
    if (select_rows.length == 0) {
      alert("데이터가 없습니다.");
      return false;
    }

    for (let i = 0; i < select_rows.length; i++) {
      let row_data = select_rows[i];
      if (strFunc.is_empty(row_data.a_money)) {
        alert("금액 입력 필요.");
        return false;
      } else if (strFunc.is_empty(row_data.a_memo)) {
        alert("적요 입력 필요.");
        return false;
      } else if (strFunc.is_empty(row_data.a_cust_name)) {
        if (row_data.a_cust_par_id == "trade_cust") {
          alert("거래처 입력 필요.");
          return false;
        }
      }
    }

    if (!confirm("등록 하시겠습니까?")) {
      return false;
    }

    let formJsonData = {
      "data_arr": select_rows,
      "is_default_val": "1",
      "is_update": "",
    };
    if (myProps.isUpdate) {
      formJsonData["is_default_val"] = "";
      formJsonData["is_update"] = "1";
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/write', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          myProps.callBackData({});
          myProps.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const cellClickedListener = useCallback((rowData: any, idx: number, e: any) => {

  }, []);

  const cellRenderer = useCallback((inOpt: any) => {
    let opObj = {
      "rowData": {},
      "idx": 0,
      "key": "",
      "value": "",
      ...inOpt
    };

    return opObj.value;
  }, []);

  const gridCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "input_tag":input_tag,
      "onChangeInput":onChangeInput,
    }
    */
    return params.input_tag;
  };

  return (
    <div>
      <div className="btn-box-left relative h-8">
        <b>총 <span className="text-blue-600">{infoArr.length}</span> 개</b>
        <span className="px-2">|</span>
        {myProps.add_btn_arr.map((item: any, idx: number) => {
          return (
            <button key={idx} className="btn btn-line-gray"
              onClick={() => { addRowByData(item); }}>{item["a_memo"]}</button>
          );
        })}
        <button className="btn btn-line-gray" onClick={() => { removeRowByData(); }}>제거</button>

        <div className="absolute right-0 top-0 btn-box-right">
          <button className="btn btn-blue" onClick={() => { onWriteMulty(); }}>등록</button>
          <button className="btn btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
        </div>
      </div>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          infoArr={infoArr}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            isGrid: true,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "left",//center,right
            table_align: "left",//center,right
            onGridReady: () => { },
            rowOnClick: cellClickedListener,
            customCellRenderer: cellRenderer,
            customGridCellRenderer: gridCellRenderer
          }}
        ></ListComponent>
      </div>
    </div>
  );
}

export default WriteMultyPopup;